<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Pending campaigns</h3>
        <p class="mt-5">Pending campaigns may need to be modified by VM</p>
      </vs-col>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div v-if="!isLoading" id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="pendingCampaigns"
        @selected="onClicked(selected.id)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Title</vs-th>
          <vs-th>Status</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.title }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip :color="statusObject(tr.status).color" class="product-order-status">
                  {{ statusObject(tr.status).text }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {},
  mixins: [campaignMixin],
  data() {
    return {
      newMessageTitle: "",
      selected: [],
      isLoading: true,
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "vp-venuecampaign",
          params: {
            id,
          },
        })
        .catch(e => {});
    },
  },
  computed: {
    ...mapGetters({
      pendingCampaigns: "venueCampaigns/pendingCampaigns",
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch("venueCampaigns/getForVenue", this.activeVenue.venueId);
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
